/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddPenaltiesDetailsToPenaltyCommandResult } from '../models/add-penalties-details-to-penalty-command-result';
import { apiPenaltiesAddPenaltiesDetailsToPenaltyPost } from '../fn/settings-penalties/api-penalties-add-penalties-details-to-penalty-post';
import { ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Params } from '../fn/settings-penalties/api-penalties-add-penalties-details-to-penalty-post';
import { apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain } from '../fn/settings-penalties/api-penalties-add-penalties-details-to-penalty-post-plain';
import { ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Params } from '../fn/settings-penalties/api-penalties-add-penalties-details-to-penalty-post-plain';
import { apiPenaltiesCreatePenaltyPost } from '../fn/settings-penalties/api-penalties-create-penalty-post';
import { ApiPenaltiesCreatePenaltyPost$Params } from '../fn/settings-penalties/api-penalties-create-penalty-post';
import { apiPenaltiesCreatePenaltyPost$Plain } from '../fn/settings-penalties/api-penalties-create-penalty-post-plain';
import { ApiPenaltiesCreatePenaltyPost$Plain$Params } from '../fn/settings-penalties/api-penalties-create-penalty-post-plain';
import { apiPenaltiesDeletePenaltyDelete } from '../fn/settings-penalties/api-penalties-delete-penalty-delete';
import { ApiPenaltiesDeletePenaltyDelete$Params } from '../fn/settings-penalties/api-penalties-delete-penalty-delete';
import { apiPenaltiesDeletePenaltyDelete$Plain } from '../fn/settings-penalties/api-penalties-delete-penalty-delete-plain';
import { ApiPenaltiesDeletePenaltyDelete$Plain$Params } from '../fn/settings-penalties/api-penalties-delete-penalty-delete-plain';
import { apiPenaltiesGetPenaltiesPost } from '../fn/settings-penalties/api-penalties-get-penalties-post';
import { ApiPenaltiesGetPenaltiesPost$Params } from '../fn/settings-penalties/api-penalties-get-penalties-post';
import { apiPenaltiesGetPenaltiesPost$Plain } from '../fn/settings-penalties/api-penalties-get-penalties-post-plain';
import { ApiPenaltiesGetPenaltiesPost$Plain$Params } from '../fn/settings-penalties/api-penalties-get-penalties-post-plain';
import { apiPenaltiesUpdatePenaltyPatch } from '../fn/settings-penalties/api-penalties-update-penalty-patch';
import { ApiPenaltiesUpdatePenaltyPatch$Params } from '../fn/settings-penalties/api-penalties-update-penalty-patch';
import { apiPenaltiesUpdatePenaltyPatch$Plain } from '../fn/settings-penalties/api-penalties-update-penalty-patch-plain';
import { ApiPenaltiesUpdatePenaltyPatch$Plain$Params } from '../fn/settings-penalties/api-penalties-update-penalty-patch-plain';
import { CreatePenaltyCommandResult } from '../models/create-penalty-command-result';
import { DeletePenaltyCommandResult } from '../models/delete-penalty-command-result';
import { GetPenaltiesQueryResult } from '../models/get-penalties-query-result';
import { UpdatePenaltyCommandResult } from '../models/update-penalty-command-result';

@Injectable({ providedIn: 'root' })
export class SettingsPenaltiesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPenaltiesGetPenaltiesPost()` */
  static readonly ApiPenaltiesGetPenaltiesPostPath = '/api/Penalties/GetPenalties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesGetPenaltiesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesGetPenaltiesPost$Plain$Response(params?: ApiPenaltiesGetPenaltiesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesQueryResult>> {
    return apiPenaltiesGetPenaltiesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesGetPenaltiesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesGetPenaltiesPost$Plain(params?: ApiPenaltiesGetPenaltiesPost$Plain$Params, context?: HttpContext): Observable<GetPenaltiesQueryResult> {
    return this.apiPenaltiesGetPenaltiesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPenaltiesQueryResult>): GetPenaltiesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesGetPenaltiesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesGetPenaltiesPost$Response(params?: ApiPenaltiesGetPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesQueryResult>> {
    return apiPenaltiesGetPenaltiesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesGetPenaltiesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesGetPenaltiesPost(params?: ApiPenaltiesGetPenaltiesPost$Params, context?: HttpContext): Observable<GetPenaltiesQueryResult> {
    return this.apiPenaltiesGetPenaltiesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPenaltiesQueryResult>): GetPenaltiesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltiesCreatePenaltyPost()` */
  static readonly ApiPenaltiesCreatePenaltyPostPath = '/api/Penalties/CreatePenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesCreatePenaltyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesCreatePenaltyPost$Plain$Response(params?: ApiPenaltiesCreatePenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyCommandResult>> {
    return apiPenaltiesCreatePenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesCreatePenaltyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesCreatePenaltyPost$Plain(params?: ApiPenaltiesCreatePenaltyPost$Plain$Params, context?: HttpContext): Observable<CreatePenaltyCommandResult> {
    return this.apiPenaltiesCreatePenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePenaltyCommandResult>): CreatePenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesCreatePenaltyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesCreatePenaltyPost$Response(params?: ApiPenaltiesCreatePenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyCommandResult>> {
    return apiPenaltiesCreatePenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesCreatePenaltyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesCreatePenaltyPost(params?: ApiPenaltiesCreatePenaltyPost$Params, context?: HttpContext): Observable<CreatePenaltyCommandResult> {
    return this.apiPenaltiesCreatePenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePenaltyCommandResult>): CreatePenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltiesAddPenaltiesDetailsToPenaltyPost()` */
  static readonly ApiPenaltiesAddPenaltiesDetailsToPenaltyPostPath = '/api/Penalties/AddPenaltiesDetailsToPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Response(params?: ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>> {
    return apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain(params?: ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Params, context?: HttpContext): Observable<AddPenaltiesDetailsToPenaltyCommandResult> {
    return this.apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>): AddPenaltiesDetailsToPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesAddPenaltiesDetailsToPenaltyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Response(params?: ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>> {
    return apiPenaltiesAddPenaltiesDetailsToPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesAddPenaltiesDetailsToPenaltyPost(params?: ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Params, context?: HttpContext): Observable<AddPenaltiesDetailsToPenaltyCommandResult> {
    return this.apiPenaltiesAddPenaltiesDetailsToPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>): AddPenaltiesDetailsToPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltiesUpdatePenaltyPatch()` */
  static readonly ApiPenaltiesUpdatePenaltyPatchPath = '/api/Penalties/UpdatePenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesUpdatePenaltyPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesUpdatePenaltyPatch$Plain$Response(params?: ApiPenaltiesUpdatePenaltyPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyCommandResult>> {
    return apiPenaltiesUpdatePenaltyPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesUpdatePenaltyPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesUpdatePenaltyPatch$Plain(params?: ApiPenaltiesUpdatePenaltyPatch$Plain$Params, context?: HttpContext): Observable<UpdatePenaltyCommandResult> {
    return this.apiPenaltiesUpdatePenaltyPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePenaltyCommandResult>): UpdatePenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesUpdatePenaltyPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesUpdatePenaltyPatch$Response(params?: ApiPenaltiesUpdatePenaltyPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyCommandResult>> {
    return apiPenaltiesUpdatePenaltyPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesUpdatePenaltyPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesUpdatePenaltyPatch(params?: ApiPenaltiesUpdatePenaltyPatch$Params, context?: HttpContext): Observable<UpdatePenaltyCommandResult> {
    return this.apiPenaltiesUpdatePenaltyPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePenaltyCommandResult>): UpdatePenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltiesDeletePenaltyDelete()` */
  static readonly ApiPenaltiesDeletePenaltyDeletePath = '/api/Penalties/DeletePenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesDeletePenaltyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesDeletePenaltyDelete$Plain$Response(params?: ApiPenaltiesDeletePenaltyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyCommandResult>> {
    return apiPenaltiesDeletePenaltyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesDeletePenaltyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesDeletePenaltyDelete$Plain(params?: ApiPenaltiesDeletePenaltyDelete$Plain$Params, context?: HttpContext): Observable<DeletePenaltyCommandResult> {
    return this.apiPenaltiesDeletePenaltyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePenaltyCommandResult>): DeletePenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltiesDeletePenaltyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesDeletePenaltyDelete$Response(params?: ApiPenaltiesDeletePenaltyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyCommandResult>> {
    return apiPenaltiesDeletePenaltyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltiesDeletePenaltyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltiesDeletePenaltyDelete(params?: ApiPenaltiesDeletePenaltyDelete$Params, context?: HttpContext): Observable<DeletePenaltyCommandResult> {
    return this.apiPenaltiesDeletePenaltyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePenaltyCommandResult>): DeletePenaltyCommandResult => r.body)
    );
  }

}
